import React, { Component } from "react"
import PropTypes from "prop-types"

// sidebar
import BulkActionsSidebar from "app/static/frontend/search-new/containers/BulkActions/sidebar/BulkActionsSidebar"

// buttons
import BulkActionsSelectButton from "app/static/frontend/search-new/containers/BulkActions/buttons/BulkActionsSelectButton"
import BulkActionsCancelButton from "app/static/frontend/search-new/containers/BulkActions/buttons/BulkActionsCancelButton"
import BulkActionsSubmitButton from "app/static/frontend/search-new/containers/BulkActions/buttons/BulkActionsSubmitButton"

// actions
import BulkActionsAlignment from "app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsAlignment"
import { BulkActionsApprove } from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsApprove"
import { BulkActionsArchive } from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsArchive"
import BulkActionsAssign from "app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsAssign"
import BulkActionsCustomField from "app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsCustomField"
import { BulkActionsExternalContact } from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsExternalContact"
import BulkActionsIssue from "app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsIssue"
import BulkActionsMerge from "app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsMerge"
import BulkActionsOrganization from "app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsOrganization"
import { BulkActionsPriority } from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsPriority"
import BulkActionsStance from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsStance"
import BulkActionsTeamPermission from "app/static/frontend/search-new/containers/BulkActions/actions/BulkActionsTeamPermission"
import { BulkActionsUnsuppress } from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsUnsuppress"

import "app/static/stylus/bulkActionsConsole.styl"

class BulkActionsConsole extends Component {
    static propTypes = {
        // from app/static/frontend/search-new/containers/BulkActions/BulkActionsConsole
        bulkActionType: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        // from shared/search/searchify/bulkactions/selectors
        bulkActionValidOptions: PropTypes.array.isRequired,
        // from shared/search/selectors
        currentCount: PropTypes.number,
        // from shared/search/searchify/bulkactions/action-creators
        disableBulkActionsMode: PropTypes.func.isRequired,
        initializeBulkActionsSlice: PropTypes.func.isRequired,
        // from shared/search/containers/FilterableListView/FilterableListViews
        quorumDataType: PropTypes.number.isRequired,
        // from shared/search/search-page-options
        uniqueFlvId: PropTypes.string.isRequired,
        // from redux-form (see https://redux-form.com/8.1.0/docs/api/props.md/)
        change: PropTypes.func.isRequired,
        form: PropTypes.string.isRequired,
        pristine: PropTypes.bool.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        invalid: PropTypes.bool.isRequired,
        isTableView: PropTypes.bool.isRequired,
        reset: PropTypes.func.isRequired,
    }

    componentDidMount() {
        // we need to initialize the Bulk Actions section of the store
        // ["filterableListViews", action.uniqueFlvId, "bulkActions"] in the reducer
        this.props.initializeBulkActionsSlice(this.props.uniqueFlvId, this.props.bulkActionValidOptions)
    }

    componentWillUnmount() {
        this.props.disableBulkActionsMode(this.props.uniqueFlvId)
    }

    renderAction(bulkActionType) {
        switch (bulkActionType) {
            case DjangIO.app.search.bulkactions.types.BulkActionType.alignment:
                return <BulkActionsAlignment />
            case DjangIO.app.search.bulkactions.types.BulkActionType.approve:
                return <BulkActionsApprove />
            case DjangIO.app.search.bulkactions.types.BulkActionType.archive:
                return <BulkActionsArchive />
            case DjangIO.app.search.bulkactions.types.BulkActionType.assign:
                return <BulkActionsAssign change={this.props.change} reset={this.props.reset} />
            case DjangIO.app.search.bulkactions.types.BulkActionType.custom_field:
                return (
                    <BulkActionsCustomField
                        form={this.props.form}
                        change={this.props.change}
                        quorumDataType={this.props.quorumDataType}
                        uniqueFlvId={this.props.uniqueFlvId}
                    />
                )
            case DjangIO.app.search.bulkactions.types.BulkActionType.issue:
                return <BulkActionsIssue change={this.props.change} />
            case DjangIO.app.search.bulkactions.types.BulkActionType.merge:
                return (
                    <BulkActionsMerge
                        bulkActionType={this.props.bulkActionType.value}
                        change={this.props.change}
                        quorumDataType={this.props.quorumDataType}
                    />
                )
            case DjangIO.app.search.bulkactions.types.BulkActionType.organization:
                return <BulkActionsOrganization change={this.props.change} />
            case DjangIO.app.search.bulkactions.types.BulkActionType.permission:
                return <BulkActionsTeamPermission change={this.props.change} />
            case DjangIO.app.search.bulkactions.types.BulkActionType.priority:
                return <BulkActionsPriority />
            case DjangIO.app.search.bulkactions.types.BulkActionType.stance:
                return <BulkActionsStance />
            case DjangIO.app.search.bulkactions.types.BulkActionType.unsuppress:
                return <BulkActionsUnsuppress />
            case DjangIO.app.search.bulkactions.types.BulkActionType.external_contact:
                return <BulkActionsExternalContact />
            default:
                return undefined
        }
    }

    render() {
        // TODO: support bulk actions in table view
        // for the time being, we don't want to show the bulk actions console in table view
        if (this.props.isTableView) {
            return null
        }

        const bulkActionTypeLabel = this.props.bulkActionType && this.props.bulkActionType.submit_label
        const qdt = DjangIO.app.models.QuorumDataType.by_value(this.props.quorumDataType)

        return (
            <div className="bulk-actions-console" data-cy="bulk-actions-console">
                <div className="bulk-actions-console-title">Bulk Actions</div>

                {this.props.bulkActionType && (
                    <div className="bulk-actions-console-primary">
                        <BulkActionsSidebar
                            quorumDataType={this.props.quorumDataType}
                            reset={this.props.reset}
                            uniqueFlvId={this.props.uniqueFlvId}
                        />

                        <div className="bulk-actions-console-form">
                            {
                                <div className="bulk-actions-console-form-byline">
                                    <p className="bulk-actions-console-form-byline-text">
                                        {this.props.currentCount
                                            ? `Click to select the items below or choose Select All to ` +
                                              `${bulkActionTypeLabel.toLowerCase()} all ${qdt.plural}`
                                            : "Please update your search so that it includes at least one result!"}
                                    </p>
                                    <BulkActionsSelectButton
                                        handleSubmit={this.props.handleSubmit}
                                        invalid={this.props.invalid}
                                        pristine={this.props.pristine}
                                        uniqueFlvId={this.props.uniqueFlvId}
                                    />
                                </div>
                            }

                            {this.renderAction(this.props.bulkActionType)}

                            <div className="bulk-actions-console-buttons">
                                <BulkActionsCancelButton uniqueFlvId={this.props.uniqueFlvId} />
                                <BulkActionsSubmitButton
                                    handleSubmit={this.props.handleSubmit}
                                    invalid={this.props.invalid}
                                    pristine={this.props.pristine}
                                    quorumDataType={this.props.quorumDataType}
                                    uniqueFlvId={this.props.uniqueFlvId}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default BulkActionsConsole
